"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSetPasswordLinkOptions = exports.validateResetPasswordLinkOptions = void 0;
var validateResetPasswordLinkOptions = exports.validateResetPasswordLinkOptions = {
  options: function options(_ref) {
    var store = _ref.store;
    var _ref2 = store.router.queryParams ? store.router.queryParams : 'null',
      token = _ref2.token;
    return {
      variables: {
        token: token
      },
      fetchPolicy: 'network-only',
      skip: !token
    };
  }
};
var validateSetPasswordLinkOptions = exports.validateSetPasswordLinkOptions = {
  options: function options(_ref3) {
    var store = _ref3.store;
    var _ref4 = store.router.queryParams ? store.router.queryParams : {},
      token = _ref4.token;
    return {
      variables: {
        token: token
      },
      fetchPolicy: 'network-only',
      skip: !token
    };
  }
};
//# sourceMappingURL=query-options.js.map